import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import BundleTypeBar from 'components/common/BundleTypeBar';
import BuyButton from 'components/BuyButton';
import Content from 'components/Content';
import SearchKeywords from 'components/common/SearchKeywords';
import { Link } from 'react-router-dom';
import { asyncFetchTemplate } from 'actions/templates';
import { priceRegular, priceRegularInit } from 'actions/order';
import * as Const from 'util/constants';
import rainbowNoticeImage from 'images/rainbow-notice.png';
import iconBW from 'images/ic-bw.png';
import iconColor from 'images/ic-color.png';
import './Template.scss';

export class Template extends Component {
  componentDidMount() {
    const { fetchTemplate } = this.props;
    const { id } = this.props.match.params;
    fetchTemplate(id);
  }

  componentDidUpdate(prevProps, prevState) {
    this.loadVoomlyVideo();
    this.syncTitle();
    this.syncDescription();
    ReactTooltip.rebuild();
  }

  syncTitle() {
    const { template } = this.props;
    if (template) {
      let title = `Doodly: ${template.title} template`;
      document.title = title;
    }
  }

  syncDescription() {
    const { template } = this.props;
    const { relatedSearches } = this.props;
    const keywords = relatedSearches.map(item => item.keywords).slice(0, 5);
    if (template) {
      let description = `The ${template.title} template comes complete with ${keywords.join(', ')} and much more.`;

      const descriptionEl = document.querySelector('meta[name="description"]');
      if (descriptionEl) {
        descriptionEl.setAttribute('content', description);
      } else {
        const descriptionEl = document.createElement('meta');
        descriptionEl.setAttribute('name', 'description');
        descriptionEl.setAttribute('content', description);
        document.head.append(descriptionEl);
      }
    }
  }

  loadVoomlyVideo() {
    const { template } = this.props;
    if (template) {
      let voomly_embed_code = template.voomly_embed_code;
      if (!voomly_embed_code || voomly_embed_code.indexOf('voomly-embed') === -1)
        voomly_embed_code =
          '<html><body style="display: flex;align-items: center;justify-content: center;"><h3>No video for this template<h3></body></html>';
      else
        voomly_embed_code = `<html style="overflow:hidden"><body style="margin:0">${voomly_embed_code}</body></html>`;

      let videoFrameHTML = voomly_embed_code.replace(/(<\/script)/gi, '/</script');
      let videoFrame = document.createElement('iframe');
      videoFrame.setAttribute('frameborder', '0');
      videoFrame.setAttribute('allowfullscreen', '');
      let video = document.getElementById('template-video');
      if (video) {
        video.innerHTML = '';
        video.appendChild(videoFrame);
      }
      let videoFrameDoc = videoFrame.document;

      if (videoFrame.contentDocument) {
        videoFrameDoc = videoFrame.contentDocument;
      } else if (videoFrame.contentWindow) {
        videoFrameDoc = videoFrame.contentWindow.document;
      }

      videoFrameDoc.open();
      videoFrameDoc.writeln(videoFrameHTML);
      videoFrameDoc.close();
    }
  }

  render() {
    const { template, query, relatedSearches, homeQuery } = this.props;
    const keywords = relatedSearches.map(item => item.keywords);
    return (
      <div className="template d-flex flex-column">
        <Header className={Const.TYPE_TEMPLATES} />
        <Content className={Const.TYPE_TEMPLATES}>
          <div className="d-flex justify-content-start">
            <BundleTypeBar className={Const.TYPE_TEMPLATES} />
          </div>
          {template && (
            <div className="breadcrumbs">
              <Link to={`/home/${homeQuery}`}>Home</Link>
              <span className="sep">&gt;</span>
              {!template.is_purchased ? (
                <Link to={`/${Const.TYPE_TEMPLATES}/${query}`}>Templates</Link>
              ) : (
                <Link to={`/my-purchases/${Const.TYPE_TEMPLATES}`}>My Purchases</Link>
              )}
              <span className="sep">&gt;</span>
              {template.title}
            </div>
          )}
          {template && !template.is_purchased && (
            <div className="rainbow-notice d-flex align-items-center">
              <img src={rainbowNoticeImage} alt="" className="mr-4 d-none d-md-inline-block" />
              <div className="notice">
                <b>
                  <span className="important mr-2">Note:</span> You will need the{' '}
                  <a href="https://www.doodly.com/rainbow/" target="_blank" rel="noopener noreferrer">
                    Doodly Rainbow addon
                  </a>{' '}
                  to switch the template from black and white, to full color.
                </b>
                <p className="mt-2 mb-0">
                  Each template comes in both
                  <img src={iconBW} alt="" />
                  black and white, as well as
                  <img src={iconColor} alt="" />
                  full color. If you own the Doodly Rainbow addon, you can easily switch back and forth between the two.
                </p>
              </div>
            </div>
          )}
          <div className="sheet">
            {template ? (
              <>
                <div className="row">
                  <div className="col-lg-6 video-container">
                    <div className="video" id="template-video" />
                  </div>
                  <div className="col-lg-6 details">
                    <h2>{template ? template.title : 'Loading...'}</h2>
                    {!template.is_purchased && (
                      <div className="d-flex align-items-center buy">
                        <div className="d-flex align-items-start price">
                          ${priceRegular}
                          <span className="init-price">${priceRegularInit}</span>
                        </div>
                        <BuyButton productId={template.clickFunnelsProductId} productType="template" />
                      </div>
                    )}
                    <div className="description">
                      {template.description && template.description.split('\n').map((line, i) => <p key={i}>{line}</p>)}
                    </div>
                  </div>
                </div>
                {!template.is_purchased && (
                  <div className="row">
                    <div className="col-12 related">
                      <h3>Related keywords</h3>
                      <SearchKeywords keywords={keywords} type={Const.TYPE_TEMPLATES} />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center">
                <i className="loading fas fa-spinner fa-spin" />
              </div>
            )}
          </div>
        </Content>
        <Footer />
        <ReactTooltip effect="solid" />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { templates, home } = state;
  return {
    template: templates.currentTemplate,
    query: templates.searchFor || '', // get the query used in templates page
    homeQuery: home.searchFor || '', // get the query used in Home page
    relatedSearches: templates.relatedSearches
  };
};

const mapDispatchToProps = dispatch => ({
  fetchTemplate: templateId => dispatch(asyncFetchTemplate(templateId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Template);
